import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';

const SlideDown = require('react-slidedown').SlideDown;

export interface VenueLinksProps {
    onSectionExpanded?: () => void;

    websiteUrl: string | null;
    onWebsiteClick?: (url: string) => void;

    facebookUrl?: string;
    instagramUrl?: string;
    pinterestUrl?: string;
    onSocialClick?: (network: 'facebook' | 'instagram' | 'pinterest') => void;

    // VenueProfileV2 component props are extended
    // from Links. Weird... So make this prop optional for now.
    isShown?: boolean;
}

export interface State {
    isShown: boolean;
}

export default class VenueLinks extends React.Component<VenueLinksProps, State> {
    constructor(props: VenueLinksProps) {
        super(props);

        this.state = {
            isShown: !!props.isShown,
        };

        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleSocialClick = this.handleSocialClick.bind(this);
        this.handleWebsiteClick = this.handleWebsiteClick.bind(this);
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable '>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Links
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && (
                            <div className='VenuePage--additional-detail VenuePage--additional-detail__links'>
                                {!!this.props.websiteUrl && (
                                    <a
                                        href={this.props.websiteUrl}
                                        onClick={this.handleWebsiteClick}
                                        target='_blank'
                                        className='VenuePage--website-link'
                                    >
                                        VIEW WEBSITE
                                    </a>
                                )}

                                {!!this.props.facebookUrl && (
                                    <a
                                        href={this.props.facebookUrl}
                                        target='_blank'
                                        className='VenuePage--social-link'
                                        onClick={() => this.handleSocialClick('facebook')}
                                    >
                                        <i className='icon-hb-facebook' />
                                    </a>
                                )}
                                {!!this.props.instagramUrl && (
                                    <a
                                        href={this.props.instagramUrl}
                                        target='_blank'
                                        className='VenuePage--social-link'
                                        onClick={() => this.handleSocialClick('instagram')}
                                    >
                                        <i className='icon-hb-nx-instagram' />
                                    </a>
                                )}
                                {!!this.props.pinterestUrl && (
                                    <a
                                        href={this.props.pinterestUrl}
                                        target='_blank'
                                        className='VenuePage--social-link'
                                        onClick={() => this.handleSocialClick('pinterest')}
                                    >
                                        <i className='icon-hb-nx-pinterest' />
                                    </a>
                                )}
                            </div>
                        )}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        const trigger = !this.state.isShown;
        this.setState({ isShown: !this.state.isShown });
        if (trigger) {
            this.props.onSectionExpanded && this.props.onSectionExpanded();
        }
    }

    private handleSocialClick(network: 'facebook' | 'instagram' | 'pinterest') {
        if (!!this.props.onSocialClick) {
            this.props.onSocialClick(network);
        }
    }

    private handleWebsiteClick() {
        if (!!this.props.onWebsiteClick && !!this.props.websiteUrl) {
            this.props.onWebsiteClick(this.props.websiteUrl);
        }
    }
}
